export function formatDateMonthYear(isoString: string | Date | null) {
  if (!isoString) {
    return "-";
  }

  const date = new Date(isoString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getUTCFullYear();

  return `${month} ${day}, ${year}`;
}
